/**
 * @param props
 */
import http from "../services/http";

export default (props) => {
    return {
        loading: false,
        like() {
            http.get(this.service.post.links.like).then((data) => {
                this.service.post.liked = data.likes > this.service.post.likes;
                this.service.post.likes = data.likes;
            })
        },
    }
};
